import brandName from "./logo.png"
import background from "./background.png"
import logo from "./logo.png"
import trigger from "./trigger.png"
import brandLogo from "./brandLogo.png"
import poweredby from "./poweredby.svg"
import lottieJson from "./lottie.json"
import lowRating from "./lowRating.png"
import midRating from "./midRating.png"
import highRating from "./highRating.png"
import outerBackground from "./outerBackground.jpg"
import user from "./user.png"
import videoTrigger from "./videoTrigger.webm"
import angry from "./angry.png"
import confounded from "./confounded.png"
import neutralFace from "./neutralFace.png"
import slightlySmilingFace from "./slightlySmilingFace.png"
import heartEyes from "./heartEyes.png"
import notification from "./notification.mp3"

const query_params = new URLSearchParams(window.location.search)
const hide_brand_data = query_params.get("removeIconBrandname") === "true"

export const english = {
  brandName: brandName,
  background: background,
  logo: hide_brand_data ? "" : logo,
  brandLogo: brandLogo,
  trigger: trigger,
  poweredby: poweredby,
  lottiejson: lottieJson,
  lowRating: lowRating,
  midRating: midRating,
  highRating: highRating,
  outerBackground: outerBackground,
  user: user,
  videoTrigger: videoTrigger,
  feedbackIcons: [
    angry,
    confounded,
    neutralFace,
    slightlySmilingFace,
    heartEyes,
  ],
}

export const arabic = {
  brandName: brandName,
  background: background,
  logo: hide_brand_data ? "" : logo,
  brandLogo: brandLogo,
  trigger: trigger,
  poweredby: poweredby,
  lottiejson: lottieJson,
  lowRating: lowRating,
  midRating: midRating,
  highRating: highRating,
  outerBackground: outerBackground,
  user: user,
  videoTrigger: videoTrigger,
  feedbackIcons: [
    angry,
    confounded,
    neutralFace,
    slightlySmilingFace,
    heartEyes,
  ],
}

export const bengali = {
  brandName: brandName,
  background: background,
  logo: hide_brand_data ? "" : logo,
  brandLogo: brandLogo,
  trigger: trigger,
  poweredby: poweredby,
  lottiejson: lottieJson,
  lowRating: lowRating,
  midRating: midRating,
  highRating: highRating,
  outerBackground: outerBackground,
  user: user,
  videoTrigger: videoTrigger,
  feedbackIcons: [
    angry,
    confounded,
    neutralFace,
    slightlySmilingFace,
    heartEyes,
  ],
};

export const gujarati = {
  brandName: brandName,
  background: background,
  logo: hide_brand_data ? "" : logo,
  brandLogo: brandLogo,
  trigger: trigger,
  poweredby: poweredby,
  lottiejson: lottieJson,
  lowRating: lowRating,
  midRating: midRating,
  highRating: highRating,
  outerBackground: outerBackground,
  user: user,
  videoTrigger: videoTrigger,
  feedbackIcons: [
    angry,
    confounded,
    neutralFace,
    slightlySmilingFace,
    heartEyes,
  ],
};

export const marathi = {
  brandName: brandName,
  background: background,
  logo: hide_brand_data ? "" : logo,
  brandLogo: brandLogo,
  trigger: trigger,
  poweredby: poweredby,
  lottiejson: lottieJson,
  lowRating: lowRating,
  midRating: midRating,
  highRating: highRating,
  outerBackground: outerBackground,
  user: user,
  videoTrigger: videoTrigger,
  feedbackIcons: [
    angry,
    confounded,
    neutralFace,
    slightlySmilingFace,
    heartEyes,
  ],
};

export const tamil = {
  brandName: brandName,
  background: background,
  logo: hide_brand_data ? "" : logo,
  brandLogo: brandLogo,
  trigger: trigger,
  poweredby: poweredby,
  lottiejson: lottieJson,
  lowRating: lowRating,
  midRating: midRating,
  highRating: highRating,
  outerBackground: outerBackground,
  user: user,
  videoTrigger: videoTrigger,
  feedbackIcons: [
    angry,
    confounded,
    neutralFace,
    slightlySmilingFace,
    heartEyes,
  ],
};

export const telugu = {
  brandName: brandName,
  background: background,
  logo: hide_brand_data ? "" : logo,
  brandLogo: brandLogo,
  trigger: trigger,
  poweredby: poweredby,
  lottiejson: lottieJson,
  lowRating: lowRating,
  midRating: midRating,
  highRating: highRating,
  outerBackground: outerBackground,
  user: user,
  videoTrigger: videoTrigger,
  feedbackIcons: [
    angry,
    confounded,
    neutralFace,
    slightlySmilingFace,
    heartEyes,
  ],
};

export const malayalam = {
  brandName: brandName,
  background: background,
  logo: hide_brand_data ? "" : logo,
  brandLogo: brandLogo,
  trigger: trigger,
  poweredby: poweredby,
  lottiejson: lottieJson,
  lowRating: lowRating,
  midRating: midRating,
  highRating: highRating,
  outerBackground: outerBackground,
  user: user,
  videoTrigger: videoTrigger,
  feedbackIcons: [
    angry,
    confounded,
    neutralFace,
    slightlySmilingFace,
    heartEyes,
  ],
};

export const hindi = {
  brandName: brandName,
  background: background,
  logo: hide_brand_data ? "" : logo,
  brandLogo: brandLogo,
  trigger: trigger,
  poweredby: poweredby,
  lottiejson: lottieJson,
  lowRating: lowRating,
  midRating: midRating,
  highRating: highRating,
  outerBackground: outerBackground,
  user: user,
  videoTrigger: videoTrigger,
  feedbackIcons: [
    angry,
    confounded,
    neutralFace,
    slightlySmilingFace,
    heartEyes,
  ],
};

export const kannada = {
  brandName: brandName,
  background: background,
  logo: hide_brand_data ? "" : logo,
  brandLogo: brandLogo,
  trigger: trigger,
  poweredby: poweredby,
  lottiejson: lottieJson,
  lowRating: lowRating,
  midRating: midRating,
  highRating: highRating,
  outerBackground: outerBackground,
  user: user,
  videoTrigger: videoTrigger,
  feedbackIcons: [
    angry,
    confounded,
    neutralFace,
    slightlySmilingFace,
    heartEyes,
  ],
};


export const notification_sound = notification
